// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const inputModule = require('../modules/input');
const navigationModule = require('../modules/navigation');


/**
 * Action Handlers
 */

function createActionHandlers() {

	// Handle action button press
	$(document).keypress((e) => {
		if (e.keyCode === 13) {
			$('#user-action-button').click();
		}
	});
}


/**
 * Input Handlers
 */

function createInputHandlers() {

	// Handle focus
	$('#name, #email, #organization').focus(() => {
		inputModule.removeBlockAlert();
	});

	// Handle name blur
	$('#name').blur(() => {
		inputModule.removeAlert('nameLabel', 'Your Name', true);
	});

	// Handle email blur
	$('#email').blur(() => {
		inputModule.removeAlert('emailLabel', 'Your Email', true);
	});

	// Handle organization blur
	$('#organization').blur(() => {
		inputModule.removeAlert('organizationLabel', 'Your Organization', true);
	});

	// Handle name change content
	$('#name').keydown(() => {
		inputModule.removeAlert('nameLabel', 'Your Name', true);
	});

	// Handle email change content
	$('#email').keydown(() => {
		inputModule.removeAlert('emailLabel', 'Your Email', true);
	});

	// Handle organization change content
	$('#organization').keydown(() => {
		inputModule.removeAlert('organizationLabel', 'Your Organization', true);
	});
}


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();

// Create action handlers
createActionHandlers();

// Create input handlers
createInputHandlers();

// Init reCAPTCHA
let captchaLoaded = false;
window.onload = () => {
	if (captchaLoaded !== true) {
		if (typeof grecaptcha !== 'undefined') {
			captchaLoaded = true;
			grecaptcha.ready(() => {
				grecaptcha.execute(process.env.RECAPTCHA_PUBLIC_KEY, { action: 'validate_captcha' }).then((token) => {
					$('#g-recaptcha-response').val(token);
				});
			});
		}
	}
};
